import { BaseApi } from './base-api';
import { IResponsePadrao } from '../types/response-padrao';
import { Sell } from '../types/venda';
import {
  CreateCreditCardPuchaseContract,
  CreatePixPurchaseContract,
} from '../types/create-credit-card-puchase-contract';
import { Checkout } from '../types/checkout';
import { mockIp } from '../mocks/mock-ip';
import {
  AplicarOrderBumpOptions,
  AplicarOrderBumpParams,
} from '../types/order-bump';

export class VendaApi extends BaseApi<Sell> {
  constructor() {
    super('venda');
  }

  async getPublicStatus(vendaToken: string): Promise<{ vendaId: string; status: number }> {
    return (
      await this.api.get(`/venda/status`, {
        headers: {
          Authorization: `Bearer ${vendaToken}`,
          'x-forwarded-for': mockIp,
        },
      })
    ).data;
  }

  async createCC(
    data: CreateCreditCardPuchaseContract,
  ): Promise<IResponsePadrao<Sell>> {
    return (
      await this.api.post(`${this.path}`, data, {
        //TODO: OBTER ISTO DO USUÁRIO FINAL
        headers: {
          'x-forwarded-for': mockIp,
        },
      })
    ).data;
  }

  async getInstallments(params: {
    amount: number;
    bin?: string;
    payment_method_id?: string;
    issuer_id?: string;
  }): Promise<any> {
    const { amount, bin } = params;
    return await this.api.get(`${this.path}/installments`, {
      params: { amount: String(amount), bin },
    });
  }

  async createPix(
    data: CreatePixPurchaseContract,
  ): Promise<IResponsePadrao<Sell>> {
    return (
      await this.api.post(`${this.path}`, data, {
        //TODO: OBTER ISTO DO USUÁRIO FINAL
        headers: {
          'x-forwarded-for': mockIp,
        },
      })
    ).data;
  }

  async createPaypalOrder(
    data: CreatePixPurchaseContract,
  ): Promise<IResponsePadrao<{ orderId: string; vendaId: string; vendaToken: string }>> {
    return (
      await this.api.post(`${this.path}/paypal/create-order`, data, {
        headers: {
          'x-forwarded-for': mockIp,
        },
      })
    ).data;
  }

  async capturePaypal(data: {
    vendaId: string;
    paypalOrderId: string;
  }): Promise<IResponsePadrao<any>> {
    return (
      await this.api.post(`${this.path}/paypal/capture`, data, {
        headers: {
          'x-forwarded-for': mockIp,
        },
      })
    ).data;
  }

  async createPaypalSubscription(
    data: CreatePixPurchaseContract,
  ): Promise<
    IResponsePadrao<{
      subscriptionId: string;
      vendaId: string;
      vendaToken: string;
      approveUrl: string;
    }>
  > {
    return (
      await this.api.post(`${this.path}/paypal/create-subscription`, data, {
        headers: {
          'x-forwarded-for': mockIp,
        },
      })
    ).data;
  }

  async activatePaypalSubscription(data: {
    vendaId: string;
    subscriptionId: string;
  }): Promise<IResponsePadrao<any>> {
    return (
      await this.api.post(`${this.path}/paypal/activate-subscription`, data, {
        headers: {
          'x-forwarded-for': mockIp,
        },
      })
    ).data;
  }

  async aplicarCupom(
    codigo: string,
    checkoutId: string,
    recaptcha: string,
  ): Promise<IResponsePadrao<Checkout>> {
    return (
      await this.api.post(
        `${this.path}/cupom-desconto`,
        {
          codigo,
          checkoutId,
          recaptchaToken: recaptcha,
        },
        {
          //TODO: OBTER ISTO DO USUÁRIO FINAL
          headers: {
            'x-forwarded-for': mockIp,
          },
        },
      )
    ).data;
  }

  async aplicarOrderBump(
    { orderBumpId, checkoutId, applied }: AplicarOrderBumpParams,
    recaptcha: string,
    opts?: AplicarOrderBumpOptions,
  ): Promise<IResponsePadrao<Checkout>> {
    const headers: Record<string, string> = {};

    if (opts?.idempotencyKey) {
      headers['X-Idempotency-Key'] = opts.idempotencyKey;
    }
    headers['x-forwarded-for'] = mockIp;

    const payload = {
      orderBumpId,
      checkoutId,
      applied,
      recaptchaToken: recaptcha,
    };

    const res = await this.api.post<IResponsePadrao<Checkout>>(
      `${this.path}/order-bump`,
      payload,
      {
        headers,
        signal: opts?.signal,
      },
    );

    return res.data;
  }
}
